import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material/";
import { useUsuario } from "../../context/usuario-context";
import myfuctions from "../../services/myfunctions";
import Cuadro from "../../Layout/Cuadro";
import LoadingButton from "@mui/lab/LoadingButton";
import { styled } from "@mui/material/styles";
import mujer_7 from "../../assets/images/mujer_7.png";
import { useHistory } from "react-router-dom";
import "./SopaLetrasGame.css";

const CerrarButton = styled(LoadingButton)(({ theme }) => ({
  color: theme.palette.getContrastText("#000"),
  backgroundColor: "#1a5080",
  "&:hover": {
    backgroundColor: "#85a537",
  },
  width: "100px",
  height: "36px",
  fontWeight: "bold",
  fontSize: "12px",
  borderRadius: "20px",
  lineHeight: 1.2,
  boxShadow:
    "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
}));

function SopaLetrasGame() {
  const { dataUser, config } = useUsuario();
  const [error, setError] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [finish, setFinish] = useState(dataUser.sopaletra);
  let history = useHistory();
  let count = 0;

  useEffect(() => {
    var words = [
      "Poloatierra",
      "Familia",
      "Ahorro",
      "Seguridad",
      "Vive",
      "Energía",
      "Afinia",
      "Luz",
      "Alegría",
    ];
    window.wordfindgame.create(words, "#puzzle", "#words");
    var puzzle = window.wordfind.newPuzzle(words, {
      height: 18,
      width: 18,
      orientations: [
        "horizontal",
        "vertical",
        "verticalUp",
        "diagonal",
        "diagonalUp",
      ],
      fillBlanks: true,
      preferOverlap: false,
    });
    window.wordfind.print(puzzle);
    window.wordfindgame.onClompleteWord(function (word) {
      count = count + 1;
      if (count === words.length) {
        console.log("Termino");
        update();
      }
    });
  });

  let update = async () => {
    try {
      setFinish(true);
      await myfuctions
        .updateSopaLetras(dataUser.userId)
        .then((result) => {})
        .catch((error) => {
          console.log(error);
          setError(true);
        });
    } catch (error) {
      console.log(error);
      setError(true);
    }
  };

  if (finish) {
    return (
      <Cuadro bgCuadro="#fff">
        <Grid container>
          <Grid item xs={12} className="cCongratulations">
            <Typography
              variant="h3"
              className="congratulations"
              align="justify"
            >
              ¡FELICITACIONES!
            </Typography>
          </Grid>
          <Grid item xs={12} md={8}>
            <div className="puntosImg">
              <Typography
                variant="subtitule1"
                className="ctextPuntos"
                align="center"
              >
                Completaste<br></br>
                la sopa de letras<br></br>
                exitosamente
                <br></br>
                <br></br>
                <CerrarButton
                  variant="contained"
                  loadingPosition="start"
                  style={{ marginTop: "10px" }}
                  onClick={() => history.push("/")}
                >
                  Cerrar
                </CerrarButton>
              </Typography>
            </div>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ display: { xs: "none", md: "block" } }}
          >
            <div className="divNino">
              <img src={mujer_7} alt="Chica" className="chicaPlanchaImgS" />
            </div>
          </Grid>
        </Grid>
      </Cuadro>
    );
  }

  return (
    <div>
      <div className="cuadroSopa" style={{ backgroundColor: "#fff" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <div id="puzzle"></div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div id="words"></div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default SopaLetrasGame;
